import { FC, PropsWithChildren } from 'react';
import { merge } from 'lodash';
import { ConfigContext, ConfigContextType, defaultContextValues } from './config-context.ts';

export type ConfigProviderProps = PropsWithChildren & Partial<ConfigContextType>;

export const ConfigProvider: FC<ConfigProviderProps> = ({ children, ...props }) => {
  return <ConfigContext.Provider value={merge(defaultContextValues, props)}>{children}</ConfigContext.Provider>;
};
